export default {"src":"/_next/static/media/google.217e42e9.svg","height":62,"width":192};